import { render, staticRenderFns } from "./DynamicEnvRecordsInfo.vue?vue&type=template&id=5cb992f7"
import script from "./DynamicEnvRecordsInfo.vue?vue&type=script&lang=js"
export * from "./DynamicEnvRecordsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports